import { APISchema } from 'shared/api/APISchema';
import { FeatureToggle } from 'shared/settings/CarrierSettingsAPI';
import { useFlag } from 'shared/settings/FeatureToggles';
import { Schema } from 'yup';
import { ZodType } from 'zod';

export function useFlaggedSchema<TData>(
  feature: FeatureToggle,
  yupSchema: Schema<TData>,
  zodSchema: ZodType<TData>,
): APISchema<TData> {
  const isZodSchemaEnabled = useFlag(feature);

  return isZodSchemaEnabled ? zodSchema : yupSchema;
}
